import React, { useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { Sidebar } from './Sidebar';
import { useAppContext } from '../../lib/store';
import { Sheet, SheetContent, SheetTrigger } from '../ui/sheet';
import { Button } from '../ui/button';
export function AppLayout() {
  const {
    auth
  } = useAppContext();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  if (!auth.isAuthenticated) {
    return <Navigate to="/login" replace data-id="element-32" />;
  }
  return <div className="flex h-screen bg-slate-50 overflow-hidden" data-id="element-33">
      {/* Desktop Sidebar */}
      <div className="hidden md:block w-64 flex-shrink-0" data-id="element-34">
        <Sidebar data-id="element-35" />
      </div>

      {/* Mobile Sidebar & Content */}
      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-36">
        {/* Mobile Header */}
        <header className="md:hidden bg-white border-b h-16 flex items-center px-4 justify-between" data-id="element-37">
          <div className="flex items-center" data-id="element-38">
            <img src="https://cdn.magicpatterns.com/uploads/fwae64AkjzR1PZNPwPqUJx/simtech_(1).svg" alt="Simtech" className="h-8" data-id="element-39" />
          </div>
          <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen} data-id="element-40">
            <SheetTrigger asChild data-id="element-41">
              <Button variant="ghost" size="icon" data-id="element-42">
                <Menu className="w-6 h-6" data-id="element-43" />
              </Button>
            </SheetTrigger>
            <SheetContent side="left" className="p-0 w-64 bg-primary border-r-0" data-id="element-44">
              <Sidebar onNavigate={() => setMobileMenuOpen(false)} data-id="element-45" />
            </SheetContent>
          </Sheet>
        </header>

        {/* Main Content */}
        <main className="flex-1 overflow-auto p-4 md:p-8" data-id="element-46">
          <div className="max-w-7xl mx-auto" data-id="element-47">
            <Outlet data-id="element-48" />
          </div>
        </main>
      </div>
    </div>;
}